import { fetch } from '../../utils/dataAccess';

export const error = (error) => {
  return { type: 'PAYMENTS_SHOW_ERROR', error };
}

export const loading = (loading) => {
  return { type: 'PAYMENTS_SHOW_LOADING', loading };
}

export const success = (retrieved) => {
  return { type: 'PAYMENTS_SHOW_SUCCESS', retrieved };
}

export const errorVoucher = (error) => {
  return { type: 'VOUCHER_SHOW_ERROR', error };
}

export const retrieve = (id) => {
  return dispatch => {
    dispatch(loading(true));

    return fetch(id)
      .then(response =>
        response
          .json()
          .then(retrieved => {
            dispatch(loading(false));
            dispatch(success(retrieved.data));
          })
      )
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };

}

export const voucher = (values) => {
  return dispatch => {
    dispatch(loading(true));

    return fetch(`vouchers/discount_preview`, { method: 'post', body: JSON.stringify(values) })
      .then(response =>
        response
          .json()
          .then(retrieved => {
            dispatch(loading(false));
            dispatch(success(retrieved.data));
          })
      )
      .catch(e => {
        dispatch(loading(false));
        console.log(e.message);
        dispatch(errorVoucher(e.message));
      });
  };
}
